module.exports = __webpack_public_path__ + "media/images/front/recorte_3-02530b9d20d71d004c390deace58ec8b.png";